document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form#cart');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    const submitter = e.submitter;
    // Only intercept the real Checkout button
    if (!submitter || submitter.name !== 'checkout') return;

    e.preventDefault();

    submitter.disabled = true;

    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

      const res = await fetch('/apps/pk-draft-checkout/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cart })
      });

      const out = await res.json();
      if (!out || !out.url) throw new Error(out?.error || 'No checkout URL returned');

      window.location.href = out.url;
    } catch (err) {
      console.error('[Packora Draft Checkout] failed:', err);
      alert('Could not start checkout. Please try again.');
      submitter.disabled = false;
    }
  });
});